<ol class="breadcrumb">
  <li class="breadcrumb-item">
      <span class="cursor-pointer" (click)="goBack()">
        <i class="feather icon-arrow-left btn-icon-prepend"></i> Back
      </span>
  </li>
</ol>
